import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { ObjectionMasterItem } from './model/objectionsMaster'

export const apiGetObjectionMasters = async (domain: number): Promise<ObjectionMasterItem[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.get(`${apiSuffixUrl}/api/ObjectionMaster/`, {
    params: { domain }
  }).then(response => response.data ?? [])
}
